import React, { useState } from 'react';
import Leaderboard from './Leaderboard';

const LeaderboardOverlay = ({ gameState, leaderboard, players }) => {
  const [showLeaderboard, setShowLeaderboard] = useState(false);


  if (gameState.phase === 'lobby') return null;

  return (
    <>
      <button className='showl' onClick={() => setShowLeaderboard(true)}>📊</button>
      
      {showLeaderboard && (
        <div className="overlay">
          <div className="relative bg-white rounded-lg p-6 max-w-md w-full">
            <button
              className="showl"
              onClick={() => setShowLeaderboard(false)}
            > X
            </button>
            <div>
              <Leaderboard leaderboard={leaderboard} players={players} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeaderboardOverlay;